import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

function Sidebar() {
  const { user, logout } = useAuth();
  const [collapsedGroups, setCollapsedGroups] = useState({});

  const toggleGroup = (label) => {
    setCollapsedGroups((prev) => ({ ...prev, [label]: !prev[label] }));
  };

  const canSeeSuperAdminMenu = user?.is_super_admin;
  const isOrgAdmin = user?.is_admin;

  const menuGroups = [
    {
      label: 'Quản lý',
      items: [
        { id: 'dashboard', label: 'Dashboard' },
        ...(canSeeSuperAdminMenu ? [{ id: 'organizations', label: 'Organizations' }] : []),
        ...(isOrgAdmin || canSeeSuperAdminMenu ? [{ id: 'users', label: 'Users' }] : []),
      ],
    },
    {
      label: 'Thiết bị & Video',
      items: [
        { id: 'videos', label: 'Videos' },
        { id: 'video-sessions', label: 'Video Sessions' },
        { id: 'vr-glasses', label: 'VR Glasses' },
      ],
    },
    {
      label: 'Khảo sát & Đánh giá',
      items: [
        { id: 'questionnaires', label: 'Questionnaires' },
        { id: 'assessments', label: 'Assessments' },
        { id: 'ibs-form-submissions', label: 'IBS Form Submissions' },
      ],
    },
    {
      label: 'Downloads',
      items: [
        { id: 'downloads', label: 'Downloads' },
      ],
    },
  ];

  return (
    <aside className="sidebar">
      <div className="sidebar-header">
        <h2>Admin Panel</h2>
      </div>

      <nav className="sidebar-nav">
        {menuGroups.map((group) => {
          const isCollapsed = !!collapsedGroups[group.label];
          return (
            <div className="nav-group" key={group.label}>
              <button
                type="button"
                className="nav-group-toggle"
                onClick={() => toggleGroup(group.label)}
              >
                <span className="nav-group-label">{group.label}</span>
                <span className={`nav-group-arrow ${isCollapsed ? 'collapsed' : ''}`}>▾</span>
              </button>
              {!isCollapsed && group.items.map((item) => (
                <NavLink
                  key={item.id}
                  to={`/${item.id}`}
                  className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
                >
                  {item.label}
                </NavLink>
              ))}
            </div>
          );
        })}
      </nav>

      <div className="sidebar-footer">
        <div className="user-info">
          <p className="user-name">{user?.full_name || user?.username}</p>
          {user?.organization_name && (
            <p className="user-org">{user.organization_name}</p>
          )}
          {user?.is_super_admin && (
            <p className="user-role">Super Admin</p>
          )}
        </div>
        <button className="btn-logout" onClick={logout}>
          Logout
        </button>
      </div>
    </aside>
  );
}

export default Sidebar;
